export interface ApiResponse<TData = unknown> {
  success: boolean;
  msg: string;
  status: { code: number | string; message: string };
  formattedErrors: Array<string | Record<string, string>> | false;
  errors: Record<string, string> | string[] | false;
  warnings: Record<string, string> | string[] | false;
  data: TData;
  messages: Array<{ type?: string; message?: string }>;
}

export class ApiError extends Error {
  public readonly response: ApiResponse<unknown>;
  constructor(message: string, response: ApiResponse<unknown>) {
    super(message);
    this.name = 'ApiError';
    this.response = response;
  }

  /** Flat list of human-readable error messages. */
  public get errorList(): string[] {
    const out: string[] = [];
    const { errors, formattedErrors } = this.response;
    if (Array.isArray(errors)) out.push(...errors);
    else if (errors && typeof errors === 'object') out.push(...Object.values(errors));
    if (Array.isArray(formattedErrors)) {
      for (const err of formattedErrors) {
        if (typeof err === 'string') out.push(err);
        else if (err && typeof err === 'object') out.push(...Object.values(err));
      }
    }
    if (out.length === 0) out.push(this.response.msg || this.message);
    return out;
  }
}
